import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextColumnBreak32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconTextColumnBreak32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17 6a2 2 0 0 0-2 2v16h-2a1 1 0 1 0 0 2h2a2 2 0 0 0 2-2V8h2a1 1 0 1 0 0-2zM3 10a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m1-5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1M22 9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm-1 9a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m1-5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextColumnBreak32);
